import { render, staticRenderFns } from "./CompraParciais.vue?vue&type=template&id=a092daa0&scoped=true"
import script from "./CompraParciais.vue?vue&type=script&lang=js"
export * from "./CompraParciais.vue?vue&type=script&lang=js"
import style0 from "./CompraParciais.vue?vue&type=style&index=0&id=a092daa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a092daa0",
  null
  
)

export default component.exports